import Tippy, { TippyProps } from '@tippyjs/react';
import { IContextMenuCheckbox, IContextMenuItem } from '../interfaces/ContextMenu';
import React from 'react';
import { hideAll } from 'tippy.js';
import { ContextMenuComponent } from './ContextMenuComponent';

interface CustomContextSubMenuProps {
    items: Array<IContextMenuItem | IContextMenuCheckbox>;
    className?: string;
    isSubMenu?: boolean;
}

export const CONTEXT_MENU_DELAY_MS = 550;
export const CONTEXT_MENU_MAX_WIDTH = 400;

function ContextSubMenu(props: CustomContextSubMenuProps & TippyProps) {
    const { items, className, children } = props;

    const onCloseMenu = (): void => {
        hideAll();
    };

    return (
        <Tippy
            duration={0}
            hideOnClick={false}
            placement="right-start"
            offset={[0, 0]}
            arrow={false}
            interactive
            allowHTML
            theme={'contextMenu'}
            delay={CONTEXT_MENU_DELAY_MS}
            maxWidth={CONTEXT_MENU_MAX_WIDTH}
            content={<ContextMenuComponent items={items} className={className} onCloseMenu={onCloseMenu} />}
        >
            {children}
        </Tippy>
    );
}

export default ContextSubMenu;
